import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import {
  PaymentMethodCreateParams,
  StripeCardElementChangeEvent,
  StripeCardElementOptions,
  StripeElementsOptions,
} from '@stripe/stripe-js'
import { StripeCardComponent, StripeService } from 'ngx-stripe'

import { PaymentProviderConfiguration } from '../payment-provider-configuration'

@Component({
  selector: 'mmx-stripe-form',
  templateUrl: './stripe-form.component.html',
  styleUrls: ['./stripe-form.component.scss'],
  standalone: false,
})
export class StripeFormComponent implements OnInit {
  @Input() providerConfiguration: PaymentProviderConfiguration | undefined

  @Output() completed = new EventEmitter<boolean>()

  @ViewChild(StripeCardComponent) stripeCardComponent?: StripeCardComponent

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        color: getComputedStyle(document.body).getPropertyValue('color').trim(),
        iconColor: getComputedStyle(document.body)
          .getPropertyValue('color')
          .trim(),
        '::placeholder': {
          color: getComputedStyle(document.body)
            .getPropertyValue('--secondary-text')
            .trim(),
        },
      },
      invalid: {
        iconColor: getComputedStyle(document.body)
          .getPropertyValue('--warn-color')
          .trim(),
        color: getComputedStyle(document.body)
          .getPropertyValue('--warn-color')
          .trim(),
      },
    },
    hidePostalCode: true,
  }

  elementsOptions: StripeElementsOptions = {}

  constructor(private stripeService: StripeService) {}

  ngOnInit(): void {
    if (this.providerConfiguration?.locale) {
      this.elementsOptions = {
        locale: this.providerConfiguration?.locale,
      }
    }

    if (!this.providerConfiguration?.stripePublicKey) {
      throw new Error('Stripe Public Key is missing')
    }

    this.stripeService.setKey(
      this.providerConfiguration.stripePublicKey,
      { stripeAccount: this.providerConfiguration.stripeAccount },
    )
  }

  handleChange(event: StripeCardElementChangeEvent) {
    if (event.complete) {
      this.completed.emit(true)
    } else {
      this.completed.emit(false)
    }
  }

  confirmPayment(clientSecret: string, billingDetails: PaymentMethodCreateParams.BillingDetails) {
    if (!this.stripeCardComponent) {
      throw this.getStripeMissingError()
    }

    return this.stripeService.confirmCardPayment(clientSecret, {
      payment_method: {
        card: this.stripeCardComponent.element,
        billing_details: billingDetails,
      },
    })
  }

  confirmSetupIntent(clientSecret: string, billingDetails: PaymentMethodCreateParams.BillingDetails) {
    if (!this.stripeCardComponent) {
      throw this.getStripeMissingError()
    }

    return this.stripeService.confirmCardSetup(clientSecret, {
      payment_method: {
        card: this.stripeCardComponent.element,
        billing_details: billingDetails,
      },
    })
  }

  private getStripeMissingError(): Error {
    return new Error('Stripe card component is missing')
  }
}
